export const services = [
  {
    number: '01',
    title: 'Architecture',
    description: 'Thoughtful spaces shaped by context, function and everyday experience.',
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=85',
  },
  {
    number: '02',
    title: 'Interior Design',
    description: 'Warm, refined interiors balancing materials, light and functionality.',
    image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=85',
  },
  {
    number: '03',
    title: 'Renovation',
    description: 'Transforming existing spaces through careful planning and contemporary design.',
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1200&q=85',
  },
  {
    number: '04',
    title: 'Space Planning',
    description: 'Clear, intelligent layouts that make every square metre work harder.',
    image: 'https://images.unsplash.com/photo-1600607688969-a5bfcd646154?auto=format&fit=crop&w=1200&q=85',
  },
  {
    number: '05',
    title: 'Design Consultation',
    description: 'Experienced perspective for the decisions that shape a project.',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=85',
  },
];

export const projects = [
  {
    title: 'Hillside Residence',
    category: 'Residential',
    description: 'A contemporary home designed around landscape, natural light and quiet materiality.',
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1600&q=90',
  },
  {
    title: 'Atelier House',
    category: 'Residential',
    description: 'A calm urban residence balancing privacy, openness and tactile materials.',
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1600&q=90',
  },
  {
    title: 'North & Co. Workspace',
    category: 'Commercial',
    description: 'A flexible workplace designed around collaboration, focus and natural light.',
    image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1600&q=90',
  },
  {
    title: 'Courtyard Home',
    category: 'Residential',
    description: 'A private garden residence organized around light, air and daily rituals.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=90',
  },
  {
    title: 'Studio Twenty',
    category: 'Commercial',
    description: 'An understated creative studio where structure and atmosphere meet.',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=90',
  },
  {
    title: 'Coastal Retreat',
    category: 'Hospitality',
    description: 'A quietly expressive retreat shaped by its relationship to the horizon.',
    image: 'https://images.unsplash.com/photo-1600607688969-a5bfcd646154?auto=format&fit=crop&w=1600&q=90',
  },
];

export const galleryItems = [
  ['Morning light', 'A quiet threshold between inside and out.', 'https://images.unsplash.com/photo-1600607688969-a5bfcd646154?auto=format&fit=crop&w=1200&q=85'],
  ['Natural stone', 'Material selected for its changing character.', 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1200&q=85'],
  ['The courtyard', 'A pause at the centre of the home.', 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=85'],
  ['Soft geometry', 'Simple lines, carefully proportioned.', 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=85'],
  ['Gathering space', 'Designed for connection and ease.', 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=85'],
  ['Tactile details', 'The small decisions make the room.', 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1200&q=85'],
  ['Open study', 'A considered place to think and work.', 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=85'],
  ['Evening calm', 'A room that changes with the day.', 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=85'],
  ['Material study', 'Texture, tone and natural imperfection.', 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1200&q=85'],
].map(([title, description, image]) => ({ title, description, image }));

export const testimonials = [
  {
    quote: 'FORMA understood how we wanted to live before they drew a single line. The result feels completely ours.',
    name: 'Clara & James',
    project: 'Hillside Residence',
  },
  {
    quote: 'Every detail has been considered, but nothing feels over-designed. It is a joy to work in every day.',
    name: 'Maya Chen',
    project: 'North & Co. Workspace',
  },
  {
    quote: 'They brought clarity to a complicated renovation and made the whole process feel calm and purposeful.',
    name: 'Daniel Ross',
    project: 'Courtyard Home',
  },
];

export const processSteps = [
  ['01', 'Discover', 'We listen, observe and understand the context, ambitions and everyday life behind your project.'],
  ['02', 'Define', 'Together we establish a clear vision, scope and direction for the work ahead.'],
  ['03', 'Design', 'We develop the details, materials and atmosphere that bring the idea into focus.'],
  ['04', 'Deliver', 'From first drawing to final finish, we guide the project with care and precision.'],
].map(([number, title, description]) => ({ number, title, description }));